import React, { useEffect, useState } from 'react';
import HomePage from './pages/HomePage';
import FAQPage from './pages/FAQPage';
import NotFoundPage from './pages/NotFoundPage';
import { Toaster } from './toaster';
import './index.css';

interface AppProps {
  initialPath?: string;
}

function App({ initialPath }: AppProps = {}) {
  const [path, setPath] = useState(
    initialPath || (typeof window !== 'undefined' ? window.location.pathname : '/')
  );

  useEffect(() => {
    const updatePath = () => setPath(window.location.pathname);
    window.addEventListener('popstate', updatePath);
    window.addEventListener('app:navigate', updatePath as EventListener);
    return () => {
      window.removeEventListener('popstate', updatePath);
      window.removeEventListener('app:navigate', updatePath as EventListener);
    };
  }, []);

  return (
    <>
      <Toaster />
      {path === '/' ? <HomePage /> : path === '/faq' || path === '/faq/' || path === '/faq.html' ? <FAQPage /> : <NotFoundPage />}
    </>
  );
}

export default App;
